import { Link } from "react-router-dom";
import {
  FaTaxi,
  FaPhoneAlt,
  FaWhatsapp,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPaperPlane,
} from "react-icons/fa";
import { PHONE_TEL, PHONE_DISPLAY, WHATSAPP_URL, WHATSAPP_DISPLAY, ADDRESS, EMAIL, EMAIL_MAILTO } from "../../data/config";
import "./layout.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-top">
          <div className="footer-col footer-brand">
            <Link to="/" className="logo">
              <span className="logo-mark"><FaTaxi /><span className="logo-badge">24/7</span></span>
              <span className="logo-text">Taxi<span>24hrs</span></span>
            </Link>
            <p>
              Reliable, fast and affordable taxi booking service. Book your ride
              in seconds and travel in comfort, 24 hours a day.
            </p>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/taxis">Our Taxis</Link></li>
              <li><Link to="/gallery">Gallery</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact Info</h4>
            <ul className="contact-list">
              <li><FaMapMarkerAlt /> {ADDRESS}</li>
              <li><FaPhoneAlt /> <a href={PHONE_TEL}>{PHONE_DISPLAY}</a></li>
              <li><FaWhatsapp /> <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">{WHATSAPP_DISPLAY}</a></li>
              <li><FaEnvelope /> <a href={EMAIL_MAILTO}>{EMAIL}</a></li>
            </ul>
            <form className="newsletter" onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder="Your email" required />
              <button type="submit" aria-label="Subscribe"><FaPaperPlane /></button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Taxi24hrs. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/faqs">Privacy Policy</Link>
            <Link to="/faqs">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
